module.exports = __webpack_public_path__ + "img/service-icon-electrician.c630f475.png";